<template>
    <div class="LiveAccount">
        <div class="nav">
            <div class="nav-item" :class="accounType == 1 ? 'active-nav-item' : ''" @click="changeAccounType(1)">{{
                $t('AccountAssets.text90') }}</div>
            <div class="nav-item" :class="accounType == 2 ? 'active-nav-item' : ''" @click="changeAccounType(2)">{{
                $t('AccountAssets.text91') }}</div>
            <div class="nav-item" v-if="mt4List.length > 0" :class="accounType == 3 ? 'active-nav-item' : ''"
                @click="changeAccounType(3)">{{
                    $t('AccountAssets.text92') }}</div>
            <div class="nav-item" v-if="mt4DemoList.length > 0" :class="accounType == 4 ? 'active-nav-item' : ''"
                @click="changeAccounType(4)">{{
                    $t('AccountAssets.text93') }}</div>
        </div>
        <div class="tabs">
            <div class="tabs-item" :class="nowNav == 'closed' ? 'active-tabs' : ''" @click="changeOrderType('closed')">
                {{ $t('AccountAssets.text24') }}</div>
            <div class="tabs-item" :class="nowNav == 'cancelled' ? 'active-tabs' : ''"
                @click="changeOrderType('cancelled')">{{ $t('AccountAssets.text25') }}</div>
        </div>
        <div class="search">
            <div class="search-line">
                <div class="search_symbol" v-show="accounType != 2">
                    <span class="search_title">{{ accounType == 1 || accounType == 2 ?
                        $t('AccountAssets.text111') : $t('AccountAssets.text110') }}:</span>
                    <el-select v-model="accounId" class="m-2" size="large">
                        <el-option v-for="item in accounList" :key="item.symbol"
                            :label="item.id + (item.name ? '(' + item.name + ')' : '')" :value="item.id" />
                    </el-select>
                </div>
                <div class="search_symbol">
                    <span class="search_title">{{ $t('AccountAssets.text14') }}:</span>
                    <el-select v-model="findSymbol" class="m-2" size="large">
                        <el-option v-for="item in productList" :key="item.symbol" :label="item.symbol"
                            :value="item.symbol" />
                    </el-select>
                </div>
            </div>
            <div class="search_date">
                <span class="search_title">
                    {{ $t('AccountAssets.text15') }}:
                </span>
                <div class="screening_picker">
                    <el-date-picker v-model="searchDate" type="daterange"
                        :start-placeholder="$t('AccountAssets.text17')" :end-placeholder="$t('AccountAssets.text18')"
                        size='large' format="MM/DD/YYYY" value-format="YYYY-MM-DD" />
                </div>
                <el-button type="primary" @click="search" class="search_btn" size="large">{{ $t('AccountAssets.text19')
                    }}</el-button>
            </div>

        </div>
        <div class="statistics" v-show="nowNav == 'closed'">
            <div class="statistics_title">
                <div class="hr"></div>
                <div>{{ $t('AccountAssets.text20') }}</div>
            </div>
            <div class="total">
                <div class="total_data">
                    <p class="total_value" :class="tradeStats.totalProfit <= 0 ? 'down' : 'up'">{{
                        tradeStats.totalProfit }}</p>
                    <p class="title">{{ $t('AccountAssets.text10') }}</p>
                </div>
                <div class="total_data" :class="tradeStats.totalSwap <= 0 ? 'down' : 'up'"
                    v-show="accounType == 1 || accounType == 2">
                    <p class="total_value">{{ tradeStats.totalSwap }}</p>
                    <p class="title">{{ $t('AccountAssets.text21') }}</p>
                </div>
                <div class="total_data">
                    <p class="total_value">{{ tradeStats.totalLots }}</p>
                    <p class="title">{{ $t('AccountAssets.text22') }}</p>
                </div>
                <div class="total_data" v-show="accounType == 1 || accounType == 2">
                    <p class="total_value">{{ tradeStats.totalCount }}</p>
                    <p class="title">{{ $t('AccountAssets.text23') }}</p>
                </div>
                <div class="total_data">
                    <p class="total_value">{{ tradeStats.totalTradeFee }}</p>
                    <p class="title">{{ $t('AccountAssets.text112') }}</p>
                </div>
            </div>
        </div>
        <ClosedPosition v-show="(accounType == 1 || accounType == 2) && nowNav == 'closed'" />
        <BillCancelled v-show="(accounType == 1 || accounType == 2) && nowNav == 'cancelled'" />
        <div class="closedPositionMT4" v-show="accounType == 3 || accounType == 4">
            <div class="table_box">
                <el-table v-loading="tloading" :data="dataPositionCloseMT4" size="small"
                    :empty-text="$t('trade.text66')">
                    <el-table-column fixed="left" prop="orderNo" :label="$t('AccountAssets.text97')" />
                    <el-table-column prop="orderTimeStr" min-width="135" :label="$t('AccountAssets.text98')" />
                    <el-table-column prop="bsType" :label="$t('trade.text51')">
                        <template #default="scope">
                            <span :class="scope.row.bsType == 1 ? 'up' : 'down'">{{ scope.row.bsType ==
                                1 ? $t('trade.text30') : $t('trade.text32') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="volume" :label="$t('trade.text52')" width="50" />
                    <el-table-column prop="symbol" :label="$t('AccountAssets.text101')" />

                    <el-table-column prop="openPrice" :label="$t('trade.text87')" v-if="nowNav == 'cancelled'" />


                    <el-table-column prop="openPrice" :label="$t('trade.text53')" v-if="nowNav == 'closed'" />
                    <el-table-column prop="closePrice" :label="$t('trade.text77')" v-if="nowNav == 'closed'"
                        min-width="95" />

                    <el-table-column prop="stopProfit" :label="$t('AccountAssets.text104')" />
                    <el-table-column prop="stopLoss" :label="$t('AccountAssets.text103')" />

                    <el-table-column prop="closeTimeStr" min-width="135" :label="$t('AccountAssets.text105')"
                        v-if="nowNav == 'closed'" />
                    <el-table-column prop="transactionFee" :label="$t('AccountAssets.text107')"
                        v-if="nowNav == 'closed'" />
                    <el-table-column prop="storage" :label="$t('AccountAssets.text108')" v-if="nowNav == 'closed'" />
                    <el-table-column prop="profit" :label="$t('trade.text76')" min-width="90" v-if="nowNav == 'closed'">
                        <template #default="scope">
                            <span :class="scope.row.profit >= 0 ? 'up' : 'down'">{{ scope.row.profit }}</span>
                        </template>
                    </el-table-column>
                    <template #empty>
                        <div class="empty">
                            <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_no_data%402x.png"
                                alt="">
                            <p>{{ $t('trade.text66') }}</p>
                        </div>
                    </template>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination :page-size="9" layout="prev, pager, next" :total="totalPage"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
    </div>
</template>
<script>
import {
    ref, computed, reactive, onBeforeUnmount, inject, onMounted
} from 'vue';
import { useStore } from 'vuex';
import apiService from '@/api/request';
import ClosedPosition from './ClosedPosition'
import BillCancelled from './BillCancelled'
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";

export default {
    name: 'LiveAccount',
    components: {
        ClosedPosition,
        BillCancelled,
    },
    setup() {
        const store = useStore();
        const { t } = useI18n()
        const emitt = inject('emitt');
        const searchDate = ref('');
        const findSymbol = ref(t('AccountAssets.text16'));
        const productList = ref([]);

        const accounList = ref([]);//当前展示账号列表
        const tloading = ref(false);
        const dataPositionCloseMT4 = ref([]);//MT4交易数据
        const pageIndex = ref(1);
        const pageSize = ref(9);
        const webList = ref([]);//web账号列表
        const mt4List = ref([]);//mt4账号列表
        const mt4DemoList = ref([])//mt4模拟账号列表

        const accounId = ref('');//查询账户ID
        const accounType = ref(1);//查询账户类型 1.web实盘 2.web模拟盘 3. MT4实盘 4.MT4模拟盘
        const totalPage = ref(1);
        const nowPage = ref(1);



        function GetAllAccountList() {
            apiService.GetAllAccountList().then(res => {
                if (res.status == 1) {
                    webList.value = res.data.webList;
                    mt4List.value = res.data.mt4List;
                    mt4DemoList.value = res.data.mt4DemoList;
                    // search();
                    changeAccounType(1);
                }
            })
        }
        const tradeStats = reactive({
            totalProfit: "",     //总平仓盈亏
            totalSwap: "",        //总隔夜利息
            totalCount: "",      //总平仓订单数
            totalLots: ""
        })
        const nowNav = ref('closed');

        //切换账户类型
        function changeAccounType(e) {


            if (e == 2) {
                apiService.SwitchQuoteInfo().then((res) => {
                    let status = res.data.demo.status;
                    if (status == 2 || status == 3) {
                        ElMessage({
                            message: t("trade.text148"),
                            type: "error",
                        });
                        return;
                    } else {
                        accounType.value = e;
                        findSymbol.value = t('AccountAssets.text16');
                        closeTradeStatsDemo();
                        His();
                    }
                    search();
                });
            } else {
                accounType.value = e;
                findSymbol.value = t('AccountAssets.text16');
                if (accounType.value == 1) {
                    accounList.value = webList.value;
                } else if (accounType.value == 3) {
                    accounList.value = mt4List.value;
                } else if (accounType.value == 4) {
                    accounList.value = mt4DemoList.value;
                }
                accounId.value = accounList.value[0].id
                if (accounType.value == 1) {
                    closeTradeStats();
                } else if (accounType.value == 2) {
                    closeTradeStatsDemo();
                }
                if (accounType.value == 1 || accounType.value == 2) {
                    His();
                } else {
                    Mt4His();
                }
                search();
            }
        }
        onMounted(() => {
            GetAllAccountList();


        })

        function mt4TradeRecordByClosed() {
            const params = {
                type: accounType.value == 3 ? 1 : 0,
                mt4Login: accounId.value,
                symbol: findSymbol.value == t('AccountAssets.text16') ? '' : findSymbol.value,
                orderTimeStart: searchDate.value ? searchDate.value[0] : '',
                orderTimeEnd: searchDate.value ? searchDate.value[1] : '',
                accounType: accounType.value,
                page: nowPage.value,
                limit: pageSize.value,
            }
            tloading.value = true;
            console.log(params);
            apiService.mt4TradeRecordByClosed(params).then(res => {
                tloading.value = false;
                console.log("mt4TradeRecordByClosed", res)
                if (res.status == 1) {
                    dataPositionCloseMT4.value = res.data.mT4TradeRecords;
                    totalPage.value = res.data.count;
                    Object.assign(tradeStats, res.data.mT4TradeRecordSummary)
                }
            })
        }
        function mt4TradeRecordByCancelled() {
            const params = {
                type: accounType.value == 3 ? 1 : 0,
                mt4Login: accounId.value,
                symbol: findSymbol.value == t('AccountAssets.text16') ? '' : findSymbol.value,
                orderTimeStart: searchDate.value ? searchDate.value[0] : '',
                orderTimeEnd: searchDate.value ? searchDate.value[1] : '',
                accounType: accounType.value,
                page: nowPage.value,
                limit: pageSize.value,
            }
            tloading.value = true;
            console.log(params);
            apiService.mt4TradeRecordByCancelled(params).then(res => {
                tloading.value = false;
                console.log("mt4TradeRecordByCancelled", res)
                if (res.status == 1) {
                    dataPositionCloseMT4.value = res.data.mT4TradeRecords;
                    totalPage.value = res.data.count;
                    Object.assign(tradeStats, res.data.mT4TradeRecordSummary)
                }
                console.log(res);
            })
        }

        function His() {
            productList.value = [];
            let params = {
                isLiveOrDemo: accounType.value == 1 ? 0 : 1,
                type: nowNav.value == 'closed' ? '0' : '1'
            };
            apiService.His(params).then((res) => {
                let list = res.data.list;
                for (let item of list) {
                    productList.value.push.apply(productList.value, item.list)
                }
                productList.value = [{ symbol: t('AccountAssets.text16') }].concat(productList.value)
            })
        }
        function Mt4His() {
            productList.value = [];
            let params = {
                isLiveOrDemo: accounType.value == 3 ? 0 : 1,
                type: nowNav.value == 'closed' ? '0' : '1',

            };
            apiService.Mt4His(params).then((res) => {
                productList.value = [{ symbol: t('AccountAssets.text16') }].concat(res.data.list)
            })
        }
        //获取已平仓订单的汇总信息 - web实盘
        function closeTradeStats() {
            let params = {
                usertoken: localStorage.userToken,
                startDate: searchDate.value ? searchDate.value[0] : '',
                endDate: searchDate.value ? searchDate.value[1] : '',
                symbol: findSymbol.value == t('AccountAssets.text16') ? '' : findSymbol.value,
                fundAccountId: accounId.value
            }
            apiService.closeTradeStats(params).then(res => {
                Object.assign(tradeStats, res.data)
            })
        }

        //获取已平仓订单的汇总信息 - web模拟盘
        function closeTradeStatsDemo() {
            let params = {
                usertoken: localStorage.userToken,
                startDate: searchDate.value ? searchDate.value[0] : '',
                endDate: searchDate.value ? searchDate.value[1] : '',
                symbol: findSymbol.value == t('AccountAssets.text16') ? '' : findSymbol.value
            }
            apiService.closeTradeStatsDemo(params).then(res => {
                Object.assign(tradeStats, res.data)
            })
        }


        /*
         * 查询-开始
         */
        function search() {
            let params = {
                beginDate: searchDate.value ? searchDate.value[0] : '',
                endDate: searchDate.value ? searchDate.value[1] : '',
                findSymbol: findSymbol.value == t('AccountAssets.text16') ? '' : findSymbol.value,
                fundAccountId: accounId.value,
                accounType: accounType.value,
            }
            if (accounType.value == 1 || accounType.value == 2) {
                if (nowNav.value == 'closed') {
                    emitt.$pub('searchClosePosition', params);
                } else {
                    emitt.$pub('searchBillPosition', params);
                }
            } else {
                totalPage.value = 0
                nowPage.value = 1
                if (nowNav.value == 'closed') {
                    mt4TradeRecordByClosed();
                } else {
                    mt4TradeRecordByCancelled();
                }
            }
        }
        //切换页面
        function handleCurrentChange(e) {
            console.log(e)
            nowPage.value = e;
            mt4TradeRecordByClosed();
        }
        /**
         * 查询-结束
         */
        //切换订单类型
        function changeOrderType(e) {
            nowNav.value = e;
            if (accounType.value == 1 || accounType.value == 2) {
                His();
            } else {
                Mt4His();
            }
            search();
        }
        return {
            findSymbol,
            productList,
            tradeStats,
            searchDate,
            search,
            nowNav,
            changeOrderType,
            accounList,
            accounId,
            accounType,
            changeAccounType,
            tloading,
            dataPositionCloseMT4,
            pageIndex,
            pageSize,
            totalPage,
            handleCurrentChange,
            mt4List,
            mt4DemoList
        }
    }
}
</script>
<style lang="less" scoped>
.LiveAccount {
    .nav {
        display: flex;
        justify-content: space-around;
        padding-top: 10px;
        border-bottom: 1px solid #D3DAE2;

        .nav-item {
            width: 220px;
            height: 50px;
            text-align: center;
            line-height: 48px;
            font-size: 18px;
            font-weight: 500;
            color: #666D7F;
            border-radius: 4px 4px 0px 0px;
            border-top: 1px solid #D3DAE2;
            border-left: 1px solid #D3DAE2;
            border-right: 1px solid #D3DAE2;
            position: relative;
            bottom: -1px;
            cursor: pointer;
            background-color: #F8F8F8;
        }

        .active-nav-item {
            background: rgba(81, 180, 241, 0.10);
            color: #51B4F1;
            border-bottom: 1px solid white;

        }
    }

    .tabs {
        height: 48px;
        display: flex;
        justify-content: center;
        border-bottom: 1px solid #F2F4FB;
        margin-top: 7px;

        .tabs-item {
            width: 50%;
            text-align: center;
            line-height: 48px;
            font-size: 16px;
            cursor: pointer;
        }

        .active-tabs {
            color: @primary-color;
            position: relative;

            &::after {
                content: "";
                display: block;
                height: 2px;
                background-color: @primary-color;
                ;
                position: absolute;
                left: 50%;
                width: 134px;
                bottom: 0;
                transform: translateX(-50%);
            }
        }
    }

    .search {
        padding: 0 28px;
        margin-top: 33px;

        .search_symbol {
            width: 250px;
            display: flex;
            justify-content: left;
            margin-right: 40px;
        }

        .search-line {
            display: flex;
            justify-content: left;
        }

        .search_title {
            margin-right: 10px;
            font-size: 14px;
            color: @text-color-secondary;
            line-height: 40px;
            white-space: nowrap;
        }

        .search_date {
            display: flex;
            justify-content: left;
            margin-top: 16px;
        }

        .screening_picker {
            width: 390px;
        }

        .hr {
            color: @text-color-secondary;
            line-height: 40px;
            margin: 0 8px;
            font-size: 14px;
        }

        .search_btn {
            width: 80px;
        }
    }

    .statistics {
        padding: 30px 20px 0 20px;

        .statistics_title {
            font-size: 18px;
            display: flex;
            justify-content: left;

            .hr {
                width: 4px;
                height: 20px;
                background: @primary-color;
                margin-right: 10px;
            }

            div {
                font-weight: 500;
            }
        }

        .total {
            display: flex;
            justify-content: left;
            margin-top: 16px;
            text-align: center;

            .total_data {
                width: 220px;
                height: 80px;
                background: @bg-color;
                border-radius: 4px;
                padding-top: 16px;

                &:not(:last-child) {
                    margin-right: 20px;
                }
            }

            .total_value {
                font-size: 20px;
                font-weight: 500;
            }

            .title {
                margin-top: 8px;
                font-size: 14px;
                color: @text-color-secondary;
            }
        }
    }

    .pagination {
        margin-top: 24px;
        float: right;
    }

    .closedPositionMT4 {
        margin-top: 30px;
    }

}
</style>
<style lang="less">
.LiveAccount {
    thead {
        th {
            background: @bg-color !important;
            color: @text-color-secondary !important;
        }
    }

    .el-table__cell {
        border-bottom: @border-color-base;
    }
}
</style>